import React from 'react';
import createReactClass from 'create-react-class';
import ReactDOM from 'react-dom';

import events from '../../events/index';
import * as constants from './constants';
import actions from './actions';

import * as api from './util/SeluxProductsRESTApi';
import Wrapper from './components/wrapper';

document.queryAll('.js-slx-product-wizard').forEach((element) => {
	actions.loadItems.listen(function (foo) {
		element.classList.add('js-slx-product-wizard--loading-facets');

		api.getItems(foo)
			.then(this.completed)
			.catch(this.failed)
			.then(() => {
				// console.log('\\      loadItems end');
				element.classList.remove('js-slx-product-wizard--loading-facets');
			});
	});

	actions.loadAccessories.listen(function (foo) {
		element.classList.add('js-slx-product-wizard--loading-accessories');

		api.getAccessories(foo)
			.then(this.completed)
			.catch(this.failed)
			.then(() => {
				// console.log(' \\     loadAccessories end');
				element.classList.remove('js-slx-product-wizard--loading-accessories');
			});
	});

	actions.loadItem.listen(function (foo) {
		element.classList.add('js-slx-product-wizard--loading-facets');

		api.getItems(foo)
			.then(this.completed)
			.catch(this.failed)
			.then(() => {
				// console.log('\\      loadItems end');
				element.classList.remove('js-slx-product-wizard--loading-facets');
			});
	});

	actions.loadAccessory.listen(function (foo) {
		element.classList.add('js-slx-product-wizard--loading-accessories');

		api.getAccessories(foo)
			.then(this.completed)
			.catch(this.failed)
			.then(() => {
				// console.log(' \\     loadAccessories end');
				element.classList.remove('js-slx-product-wizard--loading-accessories');
			});
	});

	actions.loadItemCount.listen(function (foo) {
		element.classList.add('js-slx-product-wizard--loading-item-count');

		api.getItemCount(foo)
			.then(this.completed)
			.catch(this.failed)
			.then(() => {
				// console.log('  \\    loadItemCount end');
				element.classList.remove('js-slx-product-wizard--loading-item-count');
			});
	});

	actions.loadAccessoryCount.listen(function (foo) {
		element.classList.add('js-slx-product-wizard--loading-accessory-count');

		api.getAccessoryCount(foo)
			.then(this.completed)
			.catch(this.failed)
			.then(() => {
				// console.log('   \\   loadAccessoryCount end');
				element.classList.remove('js-slx-product-wizard--loading-accessory-count');
			});
	});

	actions.loadAccessoryIdsForItems.listen(function (foo) {
		element.classList.add('js-slx-product-wizard--loading-accessory-ids');

		api.getAccessoryIdsForItems(foo)
			.then(this.completed)
			.catch(this.failed)
			.then(() => {
				// console.log('    \\  loadAccessoryIdsForItems end');
				element.classList.remove('js-slx-product-wizard--loading-accessory-ids');
				actions.loadAccessoryFacets();
				actions.loadAccessoryCount();
			});
	});

	actions.loadFacets.listen(function () {
		element.classList.add('js-slx-product-wizard--loading-items');

		api.getFacets()
			.then(this.completed)
			.catch(this.failed)
			.then(() => {
				// console.log('     \\ loadFacets end');
				element.classList.remove('js-slx-product-wizard--loading-items');
			});
	});

	actions.loadAccessoryFacets.listen(function () {
		element.classList.add('js-slx-product-wizard--loading-items');

		api.getAccessoryFacets()
			.then(this.completed)
			.catch(this.failed)
			.then(() => {
				// console.log('      \\loadAccessoryFacets end');
				element.classList.remove('js-slx-product-wizard--loading-items');
			});
	});

	const configuration = JSON.parse(element.getAttribute('data-config'));
	const state = JSON.parse(element.getAttribute('data-state'));
	actions.changeConfiguration(configuration);
	actions.initializeWizards(state);

	ReactDOM.render(<Wrapper />, element);
	let PRODUCT_MODEL_FACET_ID = constants.PRODUCT_MODEL_SLIDER_FACET_ID;

	if (window.location.host.indexOf('selux.us') !== -1 || window.location.host.indexOf('selux-us') !== -1) {
		PRODUCT_MODEL_FACET_ID = constants.PRODUCT_MODEL_SLIDER_FACET_ID_US;
	}
	// overide default product model id for slider/wizard connection
	if (configuration.hasOwnProperty('productModelFacet')) PRODUCT_MODEL_FACET_ID = configuration.productModelFacet;

	events.on('selectProductTypeInWizard', (productTypeId, facet = constants.PRODUCT_MODEL_SLIDER_FACET_ID) => {
		actions.selectPropertyById(facet, productTypeId);
		events.emit('selectedProductTypeInWizard', productTypeId);
	});
});
